import React from "react";
import PollingRefreshIndicator from "../Shared/PollingRefreshIndicator";

type CairePollingShellProps = {
  refreshing?: boolean;
  children: React.ReactNode;
};

/** Positions the shared polling loader in the top-right, matching VBC/CDI. */
const CairePollingShell: React.FC<CairePollingShellProps> = ({
  refreshing = false,
  children,
}) => (
  <div className="relative h-full min-h-0">
    <div className="pointer-events-none absolute right-4 top-3 z-10 flex items-center">
      <PollingRefreshIndicator visible={refreshing} />
    </div>
    {children}
  </div>
);

export default CairePollingShell;
